import { render } from "./internal-enrolments-export.vue?vue&type=template&id=08a95297&ts=true"
import script from "./internal-enrolments-export.ts?vue&type=script&lang=ts&external"
export * from "./internal-enrolments-export.ts?vue&type=script&lang=ts&external"

import "./internal-enrolments-export.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__